import rawData from "./categoryList.json";
import totalCountRaw from "./totalCount.json";

export interface CategoryNode {
  id: number;
  category: string;
  parent_id: number | null;
  thumb: string;
  count: string;
  child?: boolean;
  realCount?: string;
  children?: [number, CategoryNode][];
}

type RawEntry = [number, CategoryNode];

export const categoryEntries = rawData as RawEntry[];
export const categoryMap = new Map<number, CategoryNode>(categoryEntries);

export const totalCount = totalCountRaw as number;

export function categoryHref(node: { id: number; category: string; children?: unknown }): string {
  return node.children
    ? `/category/${node.category}/${node.id}`
    : `/textures/${node.category}/${node.id}`;
}
